module.exports = __webpack_public_path__ + "media/vuesrc/themes/assante/images/demo/demopage-begin-demo-illustration-697664b36f1ce089a6b44763e26d2ffa.jpg";